/**
 * v3 context breadcrumb: Org › Programme › Project
 * segments: { label, onClick?, current? }
 */
export default function BreadcrumbBar({ segments = [] }) {
  if (!segments.length) return null;
  return (
    <div className="ctx-bar">
      {segments.map((seg, i) => (
        <span key={i} style={{ display: 'contents' }}>
          {i > 0 && <span className="ctx-sep">›</span>}
          {seg.current ? (
            <span className="ctx-current">{seg.label}</span>
          ) : (
            <button
              type="button"
              className="ctx-link"
              onClick={seg.onClick}
              disabled={!seg.onClick}
            >
              {seg.label}
            </button>
          )}
        </span>
      ))}
    </div>
  );
}
